import { Platform } from 'quasar'

const myAndroidId = 'ca-app-pub-2319752517808095/4125557518';
const myIosId = 'ca-app-pub-2319752517808095/6646088691';

let adId = null;
let hideAds = null;
let initialized = false;
let adIsShown = false;
let personalizedAds = null;

function init() {
  console.log("ads.init");

  if (!Platform.is.cordova) {
    console.log("ads.init: Don't initialize ads (not on mobile)");
    return;
  }

  window.psgo.subscribeFuncs({
    "app.manufacturer.current": msg => {
      adId = getAdIdFromManufacturer(msg.dat);
      initializeAd(adId, hideAds, personalizedAds);
    },
    "app.keys.updated": msg => {
      hideAds = getHideAdsFromKeys(msg.dat.keys);
      initializeAd(adId, hideAds, personalizedAds);
    },
    "app.ads.personalized": msg => {
      personalizedAds = msg.dat;
    },
    "app.ads.initialize": msg => {
      initializeAd(adId, hideAds, personalizedAds);
    },
    "app.session.logout": msg => {
      initialized = false;
      personalizedAds = null;
    }
  });
}

function getAdIdFromManufacturer(manufacturerData) {
  console.log('ads.getAdIdFromManufacturer: manufacturerData=', manufacturerData);

  let manufacturer = manufacturerData.manufacturer;

  let rand = Math.random();
  let showManufacturerAd = manufacturer && manufacturer.admobPercent && rand < manufacturer.admobPercent;
  console.log('ads.getAdIdFromManufacturer: manufacturer=', toJson(manufacturer), ", rand=", rand, ", showManufacturerAd=", showManufacturerAd);

  if (showManufacturerAd) {
    return (window.device.platform === "Android") ? manufacturer.admobAndroidId : manufacturer.admobIosId;
  } else {
    return (window.device.platform === "Android") ? myAndroidId : myIosId;
  }
}

function getHideAdsFromKeys(keys) {
  console.log('ads.getHideAdsFromKeys: keys=', keys);
  for (var i in keys) {
    var key = keys[i];
    console.log('ads.getHideAdsFromKeys: key.name=', key.name, ', key.hideAds=', key.hideAds);
    if (key.hideAds) {
      return true;
    }
  }

  return false;
}

function initializeAd(adId, hideAds, personalizedAds) {
  console.log("ads.initializeAd: start adId=", adId, ", hideAds=", hideAds, ", personalizedAds=", personalizedAds);

  if (adId && hideAds != null && personalizedAds != null) {
    if (!hideAds && !initialized) {
      console.log("ads.initializeAd: initialize adId=", adId, ", personalizedAds=", personalizedAds);

      let adExtras = {};
      if (!personalizedAds) {
        adExtras['npa'] = '1';
      }

      window.admob.banner.config({
        id: adId,
        adExtras: adExtras
      });
      initialized = true;
    }

    if (hideAds) {
      hideAd();
    } else {
      showAd();
    }
  }
}

function toJson(manufacturer) {
  if (manufacturer == null) {
    return null;
  }

  return JSON.stringify(manufacturer);
}

function showAd() {
  console.log("ads.showAd");
  if (window.admob && window.admob.banner && adId != null && initialized && hideAds != null && !hideAds && !adIsShown) {
    console.log("ads.showAd before prepare");
    window.admob.banner.prepare();
    adIsShown = true;
    console.log("ads.showAd after prepare");
  }
}

function hideAd() {
  console.log("ads.hideAd");
  if (window.admob && window.admob.banner && adIsShown) {
    window.admob.banner.remove();
    adIsShown = false;
  }
}

export default { init, showAd, hideAd };



// WEBPACK FOOTER //
// ./src/js/ads.js